import "./EventsPast.scss";

import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";

import chevronLeft from "../../../assets/images/icons/chevron-left.svg";

import SideBar from "../../../components/SideBar/SideBar";
import TableColumn from "../../../components/TableColumn/TableColumn";
import TopNav from "../../../components/TopNav/TopNav";
import api from "../../../services/api";
import { ContainerHeader } from "../NewBarCrawlEvent/New/styles";
import {MdEdit, MdOutlineRemoveRedEye} from "react-icons/md";

const ReviewGuestList = () => {
  const { eventsId } = useParams();

  const navigate = useNavigate();

  const [listReviewGuestList, setListReviewGuestList] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(
    Number(localStorage.getItem("ListCurrentReviewGuestlist")) || 1
  );
  const records = 10;

  const [sortBy, setSortBy] = useState(null);
  const [sortDirection, setSortDirection] = useState("asc");

  const columns = [
    "Date",
    "Name",
    "Birthday",
    "Gender",
    "Status",
    "Vouchers Used",
    "Vouchers Left",
  ];

  const sortableColumns = ["Date", "Name", "Birthday", "Gender"];

  useEffect(() => {
    const storedPage = localStorage.getItem("ListCurrentReviewGuestlist");

    setCurrentPage(Number(storedPage) || 1);
  }, []);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    localStorage.setItem("ListCurrentReviewGuestlist", page);
  };

  const sortColumnsMapping = {
    Name: "name",
    Date: "date",
    Birthday: "",
    Gender: "",
  };

  const handleSort = (columnName) => {
    const backendColumnName = sortColumnsMapping[columnName];
    if (sortBy === backendColumnName) {
      setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    } else {
      setSortBy(backendColumnName);
      setSortDirection("asc");
    }
  };

  useEffect(() => {
    const fetchData = async (page) => {
      try {
        const response = await api.get(
          `/guest-list-requests/events/${eventsId}`,
          {
            params: {
              page: page,
              records: 10,
              sort_column: sortBy,
              sort: sortDirection,
            },
          }
        );

        const itemsTableColumns = response.data.requests.map((review) => ({
          id: review._id,
          user_id: review?.user_id,
          Date: review?.created_at,
          Name: review?.user_name,
          Birthday: review?.user_birthday,
          Gender: review?.user_gender,
          Status: review?.status,
          "Vouchers Used": review?.vouchers_used,
          "Vouchers Left": review?.vouchers_left,
        }));

        setListReviewGuestList(itemsTableColumns);
        setTotalPages(response.data.total);
      } catch (error) {
        console.log(error);
      }
    };

    fetchData(currentPage);
  }, [sortBy, sortDirection, currentPage, eventsId]);

  const actions = [
    {
      label: <MdOutlineRemoveRedEye size={30} color="#4F30EA" />,
      onClick: (rowData) => {
        navigate(`/users/${rowData.user_id}`);
      },
    },
  ];

  return (
    <>
      <main>
        <TopNav />
        <div className="main-container">
          <SideBar />

          <article className="page-content">
            <section className="past">
              <TableColumn
                title="Review Guestlist"
                records={records}
                actions={actions}
                columns={columns}
                data={listReviewGuestList}
                sortableColumns={sortableColumns}
                hasExport={true}
                hasSearch={true}
                totalPages={totalPages}
                currentPage={currentPage}
                onPageChange={handlePageChange}
                // fetchAllData={fetchAllData}
                onSort={handleSort}
              />
            </section>
          </article>
        </div>
      </main>
    </>
  );
};

export default ReviewGuestList;
